import { render } from "./Loader.vue?vue&type=template&id=536fa33c&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=536fa33c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Hardcore\\Documents\\LEARNING\\VUE PROJECT\\ngbo-calender\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536fa33c"]])

export default __exports__